import api from '@/services/Api'

// ----------------------------- o

const state = {
    roles: [],
    years: [],
    provinces: [],
    places: [],
    categories: {
        news: [],
        trainings: [],
        advertisements: [],
        places: [],
        wikis: [],
        products: []
    },
    agreements: [],
    areas: []
};

// ----------------------------- o

const actions = {
    'GLOBAL_REMOVE_USER': ({commit, dispatch}) => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('device_token');
        localStorage.removeItem('profile');
        commit('AUTH_REMOVE_TOKEN');
        commit('profile/PROFILE_REMOVE');
        // rootState.auth.token = '';
    },
    'GLOBAL_ROLES_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            let url = 'roles';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_ROLES_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },
    'GLOBAL_YEARS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            let url = 'years';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_YEARS_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },
    'GLOBAL_PROVINCES_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            let url = 'provinces';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_PROVINCES_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },
    'GLOBAL_PLACES_SEARCH_REQUEST': ({commit, dispatch}, tax_id) => {
        return new Promise((resolve, reject) => {
            let url = '/places?tax_id='+ tax_id;
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_PLACES_SEARCH_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },
    'GLOBAL_CATEGORIES_REQUEST': ({commit, dispatch}, type) => {
        return new Promise((resolve, reject) => {
            let url = 'categories?type='+ type
            let name = null;
            // please kill Adam Fabis
            switch(type){
                case 1 :
                    name = 'news';
                    break;
                case 2 :
                    name = 'trainings';
                    break;
                case 3 :
                    name = 'advertisements';
                    break;
                case 4 :
                    name = 'places';
                    break;
                case 5 :
                    name = 'wikis';
                    break;
                case 6 :
                    name = 'products';
                    break;
            }
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_CATEGORIES_SUCCESS', { 'data': resp.data.data, 'name': name});
                    // set default news category
                    if(name == 'news'){
                        commit('news/KNOWLEDGE_NEWS_SET_CATEGORY', resp.data.data[0].slug);
                    }
                    // set default wikis category
                    if(name == 'wikis'){
                        commit('wikis/KNOWLEDGE_WIKIS_SET_CATEGORY', resp.data.data[0].slug);
                    }
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    'GLOBAL_AGREEMENTS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            let url = 'agreements';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_AGREEMENTS_SUCCESS', resp.data.data.agreements);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },
    'GLOBAL_AREAS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            let url = 'areas';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('GLOBAL_AREAS_SUCCESS', resp.data.data.areas);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },

    // global toast
    GLOBAL_TOAST(store, text){
        this.$app.$ionic.toastController
            .create({
                message: text,
                duration: 4000,
                mode: 'ios',
                position: 'top'
            })
            .then(a => a.present())
    },
}

// ----------------------------- o

const mutations = {
    'GLOBAL_ROLES_SUCCESS': (state, resp) => {
        state.roles = resp;
    },
    'GLOBAL_YEARS_SUCCESS': (state, resp) => {
        state.years = resp;
    },
    'GLOBAL_PROVINCES_SUCCESS': (state, resp) => {
        state.provinces = resp;
    },
    'GLOBAL_PLACES_SEARCH_SUCCESS': (state, resp) => {
        state.places = resp;
    },
    'GLOBAL_CATEGORIES_SUCCESS': (state, resp) => {
        state.categories[resp.name] = resp.data;
    },
    'GLOBAL_AGREEMENTS_SUCCESS': (state, resp) => {
        state.agreements = resp;
    },
    'GLOBAL_AREAS_SUCCESS': (state, resp) => {
        state.areas = resp;
    },
}

// ----------------------------- o

export default {
    state,
    actions,
    mutations
}